import { Component, Input, OnInit } from '@angular/core';
import { Interview } from '../../interfaces/interview';

@Component({
  selector: 'app-interview',
  templateUrl: './interview.component.html',
  styleUrls: ['./interview.component.scss']
})
export class InterviewComponent implements OnInit {
  @Input() interview: Interview[];

  constructor() { }

  ngOnInit() {
  }

}
